import { Button, Grid, Typography } from '@mui/material'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'
import React from 'react'

interface MenuButtonProps {
    onClick: () => void
    caption: string
    disabled?: boolean
    color?: any
    icon?: any
    width?: number | string
    buttonStyle?: React.CSSProperties
}

function MenuButton({
    onClick,
    disabled = false,
    color = 'primary',
    icon,
    caption,
}: MenuButtonProps) {
    const { isMobile } = useScreenSize()

    return (
        <Button
            onClick={onClick}
            color={color}
            data-testid={'menu-button'}
            sx={{
                px: isMobile ? 2 : 4,
                py: 2,
                '&:disabled': {
                    cursor: 'not-allowed',
                },
                height: '100%',
            }}
            fullWidth
            disabled={disabled}
        >
            <Grid
                container
                direction="column"
                alignItems="center"
                justifyContent="center"
                width={'100%'}
                p={1}
            >
                <Grid item>{icon}</Grid>
                <Grid item>
                    <Typography>{caption}</Typography>
                </Grid>
            </Grid>
        </Button>
    )
}

export default MenuButton
